<template>
  <div id="my-provisioning" class="row reverse-mobile">
    <div class="col-12 col-md-3">
      <UserMenu></UserMenu>
    </div>
    <div class="col-12 col-md-9">
      <div class="row mb-4">
        <div class="d-flex flex-row align-items-center">
          <i class="material-icons material-icons-title mr-2">devices_other</i>
          <h2 class="mt-2">Provision Device</h2>
        </div>
      </div>

      <div v-if="!isOnNative" class="alert alert-secondary mt-4" role="alert">
        <p class="mb-0 d-flex align-content-center">
          <i class="material-icons mr-2 text-black">warning</i>
          <strong></strong> To manage your licenses, please log into Community from your corpuls simulation device.
        </p>
      </div>

      <div v-else-if="deviceLicensedToOther" class="alert alert-secondary mt-4" role="alert">
        <p class="mb-0 d-flex align-content-center">
          <i class="material-icons mr-2 text-black">warning</i> Warning!<br/>
        </p>
        <p class="mb-0 mt-2">
          This device is already licensed to another user. To license this device, you will need to revoke the license
          for the other account.<br/>
          When you have trouble to licence your product, please contact your local corpuls distributor. To find out, who
          is responsible for your region, please contact <a href="mailto:info@corpuls.com">info@corpuls.com</a> or fill
          out the contact form on
          <a
              href="https://corpuls.world/en/contact/">https://corpuls.world/en/contact/</a>.
        </p>
      </div>

      <div v-else-if="!isCurrentlyLicensed" class="alert alert-secondary mt-4" role="alert">
        <p class="mb-0 d-flex align-content-center">
          <i class="material-icons mr-2 text-black">warning</i> Warning!<br/>
        </p>
        <p class="mb-0 mt-2">
          This device is not licenced. Therefore the usage is restricted.<br/>
          Please licence your Monitor device to get the full corpuls simulation experience. When you have trouble to
          licence your product, please contact your local corpuls distributor. To find out, who is responsible for your
          region, please contact <a href="mailto:info@corpuls.com">info@corpuls.com</a> or fill out the contact form on
          <a
              href="https://corpuls.world/en/contact/">https://corpuls.world/en/contact/</a>.
        </p>
      </div>

      <div v-if="isCurrentlyLicensed  && isOnNative" class="agreement shadow rounded bg-white p-3">
        <div class="d-flex d-flex justify-content-between align-items-center">
          <h3 class="d-flex align-items-center text-capitalize contract-title">
            <i class="mr-2 material-icons text-secondary">receipt</i>
            Current License
          </h3>
          <button
              @click="relinquish()"
              class="btn btn-danger edit-button d-flex align-items-center"
          >
            <i class="material-icons mr-2">delete</i> Relinquish
          </button>
        </div>
        <strong class="d-block my-2">Details</strong>
        <div class="d-flex justify-content-space-between">
          <div class="w-40">
            <ul class="list-unstyled detail-name">
              <li class="d-flex my-1 align-items-center">
                <i class="mr-2 material-icons text-secondary">note</i>
                <em>Agreement Id:</em>
              </li>
              <li class="d-flex my-1 align-items-center">
                <i class="mr-2 material-icons text-secondary">tablet</i>
                <em>Device Serial</em>
              </li>
              <li class="d-flex my-1 align-items-center">
                <i class="mr-2 material-icons text-secondary">color_lens</i>
                <em>Current Kit Colour</em>
              </li>
            </ul>
          </div>
          <div class="w-60 mx-4">
            <ul class="list-unstyled text-capitalize detail-value">
              <li class="my-1">
                <em>{{ currentLicense.license_contract.id }}</em>
              </li>
              <li class="my-1">
                <em>{{ currentLicense.device_serial_number || "&nbsp;" }}</em>
              </li>
              <li class="shadow rounded license-colour" v-bind:class="'kit-' + (currentLicense.license_colour || 'none')"></li>
            </ul>
          </div>
        </div>
        <strong class="d-block my-2 modules">Modules Included</strong>
        <ul
            v-if="currentLicense.product_modules.length > 0 "
            class="w-100 d-flex flex-wrap list-unstyled"
        >
          <li
              v-bind:key="module.id"
              v-for="module in currentLicense.product_modules"
              class="my-1 mr-1 position-relative"
          >
            <button class="btn btn-sm btn-primary">{{ module.name }}</button>
          </li>
        </ul>
        <em v-else>We couldn't find any modules included on this licences agreement</em>
      </div>

      <h3 class="my-4">Your License Agreements</h3>
      <div
          v-bind:key="contract.id"
          v-for="contract in formattedContracts"
          class="agreement shadow rounded bg-white"
      >
        <div
            class="licensed-alert alert alert-info w-100 mt-4"
            v-show="contract.licensedToThisContract"
        >
          <em class="font-weight-bold">Your device is currently licensed to this agreement</em>
        </div>
        <div class="p-3">
          <div class="d-flex d-flex justify-content-between align-items-center">
            <h3 class="d-flex align-items-center contract-title">
              <i class="mr-2 material-icons text-secondary">note</i>
              corpuls simulation License Agreement
            </h3>

            <router-link
                v-if="contract.numberOfAvaiableLicenses > 0  && !deviceLicensedToOther && !isCurrentlyLicensed && isOnNative && deviceInfo.product === contract.product.key_name"
                class
                :to="{ name: 'my-claim', params: { contractId: contract.id} }"
            >
              <button class="btn btn-success -button d-flex align-items-center">
                <i class="material-icons mr-2">note_add</i> Claim
              </button>
            </router-link>
            <button disabled v-else class="btn btn-success -button d-flex align-items-center">
              <i class="material-icons mr-2">block</i> Unavailable
            </button>
          </div>

          <div class="my-2 licenses-left my-2">
            <strong>
              You have
              <em
                  v-bind:class="{ 'text-danger' : contract.numberOfAvaiableLicenses <= 0  }"
              >{{ contract.numberOfAvaiableLicenses }}</em> licenses available on this agreement
            </strong>
          </div>

          <strong class="d-block my-2">Details</strong>
          <div class="d-flex justify-content-space-between">
            <div class="w-40">
              <ul class="list-unstyled detail-name">
                <li class="d-flex my-1 align-items-center">
                  <i class="mr-2 material-icons text-secondary">dvr</i>
                  <em>Type:</em>
                </li>
                <li class="d-flex my-1 align-items-center">
                  <i class="mr-2 material-icons text-secondary">format_list_numbered</i>
                  <em>Licenses on agreement</em>
                </li>
                <li class="d-flex my-1 align-items-center">
                  <i class="mr-2 material-icons text-secondary">check_circle_outline</i>
                  <em>Licenses used:</em>
                </li>
                <li class="d-flex my-1 align-items-center">
                  <i class="mr-2 material-icons text-secondary">perm_identity</i>
                  <em>Agreement ID:</em>
                </li>
                <li class="d-flex my-1 align-items-center">
                  <i class="mr-2 material-icons text-secondary">date_range</i>
                  <em>Agreement Date:</em>
                </li>
                <li class="d-flex my-1 align-items-center">
                  <i class="mr-2 material-icons text-secondary">perm_identity</i>
                  <em>Customer Ref:</em>
                </li>
                <li class="d-flex my-1 align-items-center">
                  <i class="mr-2 material-icons text-secondary">shopping_cart</i>
                  <em>Purchase Order:</em>
                </li>
              </ul>
            </div>
            <div class="w-60 mx-4">
              <ul class="list-unstyled text-capitalize detail-value">
                <li class="my-1">
                  <em>{{ contract.agreement_type }}</em>
                </li>
                <li class="my-1">
                  <em>{{ contract.number_of_licenses_allowed }}</em>
                </li>

                <li class="my-1">
                  <em>{{ contract.licenses.length }}</em>
                </li>
                <li class="my-1">
                  <em>{{ contract.id }}</em>
                </li>
                <li class="my-1">
                  <em>{{ contract.agreement_creation_date }}</em>
                </li>
                <li class="my-1">
                  <em>{{ contract.cust_reference_id }}</em>
                </li>
                <li class="my-1">
                  <em>{{ contract.purchase_order_string }}</em>
                </li>
              </ul>
            </div>
          </div>

          <strong class="d-block mt-2">Notes</strong>
          <textarea
              class="w-100 mb-2"
              rows="5"
              v-model="contract.notes"
          ></textarea>
          <button class="btn btn-primary mb-2" @click="updateNotes(contract.id)">Update notes</button>

          <strong class="d-block my-2 modules">Modules Included</strong>
          <ul
              v-if="contract.product_modules.length > 0 "
              class="w-100 d-flex flex-wrap list-unstyled"
          >
            <li
                v-for="module in contract.product_modules"
                v-bind:key="module.id"
                class="my-1 mr-1 position-relative"
            >
              <button class="btn btn-sm btn-primary">{{ module.name }}</button>
            </li>
          </ul>
          <em v-else>We couldn't find any modules included on this licences agreement</em>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserMenu from "../components/UserMenu";
import licenseService from "../services/license.service";

export default {
  name: "MyProvisioning",
  computed: {
    deviceInfo() {
      return this.$store.getters.getDeviceInfo;
    },
    isOnNative() {
      return this.$store.getters.getIsOnNative;
    }
  },
  components: {
    UserMenu
  },
  data: function () {
    return {
      contracts: [],
      currentLicense: {},
      currentLicenceModules: {},
      formattedContracts: [],
      isCurrentlyLicensed: false,
      deviceLicensedToOther: false,
      isSavingNotes: false,
      licenseRequestInfo: {
        contractId: 0,
        deviceId: "",
        product: "",
        kitColour: "blue",
        deviceSerial: ""
      },
    };
  },

  methods: {
    relinquish() {
      licenseService
          .relinquishLicense(
              this.currentLicense.id,
              this.currentLicense.device_id
          )
          .then(data => {
            window.webkit.messageHandlers.relinquish.postMessage("");
            this.isCurrentlyLicensed = false;
            this.getContracts();
          });
    },

    getContracts() {
      licenseService.myContracts().then(data => {
        this.deviceLicensedToOther = data.device_licensed_to_other;
        this.contracts = data.contracts;
        this.formatContracts();
        this.getLicense();
      });
    },
    getLicense() {
      licenseService.myLicense().then(data => {
        this.currentLicense = data;
        this.getCurrentLicenceModules();
      });
    },
    
    getCurrentLicenceModules() {
      this.isCurrentlyLicensed = false;
      this.formattedContracts.forEach(contract => {
        contract.licensedToThisContract = false;
        if (contract.id === this.currentLicense.license_contract.id) {
          this.currentLicense.product_modules = contract.product_modules;
          contract.licensedToThisContract = true;
          this.isCurrentlyLicensed = true;
        }
      });
    },

    formatContracts() {
      this.formattedContracts = this.contracts;
      this.formattedContracts.forEach(contract => {
        contract.agreement_creation_date = this.formatDate(
            contract.agreement_creation_date
        );
        contract.agreement_type = this.formatLicenseType(
            contract.agreement_type
        );
        contract.numberOfAvaiableLicenses =
            contract.number_of_licenses_allowed - contract.licenses.length;
        if (contract.numberOfAvaiableLicenses < 0) {
          contract.numberOfAvaiableLicenses = 0;
        }
      });
    },
    formatDate(date) {
      let d = new Date(date),
          month = "" + (d.getMonth() + 1),
          day = "" + d.getDate(),
          year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("-");
    },
    formatLicenseType(type) {
      switch (type) {
        case 0:
          return "recurring";
        default:
          return "unknown";
      }
    },
    updateNotes(contractId) {
      const contract = this.formattedContracts.find(c => c.id === contractId);
      if (!contract) {
        console.log("Couldn't find contract to update notes");
        return;
      }

      if (this.isSavingNotes) return;
      this.isSavingNotes = true;

      licenseService.updateContractNotes(contractId, contract.notes).finally(() => {
        this.isSavingNotes = false;
        vm.$swal.fire("Success!", "Your notes have been updated", "success");
      });
    }
  },

  beforeMount() {
    this.getContracts();
  }
};
</script>

<style scoped>
button:disabled {
  background: grey;
  border-color: grey;
  opacity: 0.3;
}

.agreement {
  margin-bottom: 30px;
  min-height: 200px;
  overflow: hidden;
}

.container-table {
  display: table;
}

.container-table-row {
  display: table-row;
}

.container-table-cell {
  display: table-cell;
}

.detail-name em {
  color: #6c757d;
}

.detail-value em {
  font-style: normal;
}

.contract-title i {
  font-size: 40px;
}

.modules .btn {
  cursor: none;
}

.licenses-left {
  font-weight: bolder;
  text-align: left;

  color: #000000;
}

.licenses-left em {
  font-style: normal;
  font-size: 22px;
  font-weight: 600;
  text-align: left;

  color: #CB2E37;
}

.licensed-alert {
  background-color: #CB2E37;

  text-align: center;
  border: none;
  border-radius: 0px;
}

.licensed-alert em {
  color: #ffffff;
}

.not-native em {
  color: #6c757d;
}

.not-native i {
  color: #6c757d;
}

.noColor {
  filter: grayscale();
  opacity: 0.7;
}

.license-colour {
  display: inline-block;
  height: 35px;
  width: 35px;
  position: relative;
  font-size: 14px;
  margin-right: 4px;
  font-weight: bold;
  text-transform: capitalize;
  outline: none !important;
  border-radius: 3px;
  border: 1px solid #ccc;
  background: #efefef;
}

.kit-selected {
  position: relative;
}

/* needs to match the ones in MyLicenseClaim */
.kit-none {
  background: red; /* For browsers that do not support gradients */
  background: -webkit-linear-gradient(
      left,
      #009ee6,
      #82b753,
      #ffb1e8
  ); /* For Safari 5.1 to 6.0 */
  background: -o-linear-gradient(
      right,
      #009ee6,
      #82b753,
      #ffb1e8
  ); /* For Opera 11.1 to 12.0 */
  background: -moz-linear-gradient(
      right,
      #009ee6,
      #82b753,
      #ffb1e8
  ); /* For Firefox 3.6 to 15 */
  background: linear-gradient(
      to right,
      #009ee6,
      #82b753,
      #ffb1e8
  ); /* Standard syntax (must be last) */
}

.kit-camo {
  color: white;
  background: red; /* For browsers that do not support gradients */
  background: -webkit-linear-gradient(
    left,
    #1b5e20,
    #A88049,
    #212121
  ); /* For Safari 5.1 to 6.0 */
  background: -o-linear-gradient(
    right,
    #1b5e20,
    #A88049,
    #212121
  ); /* For Opera 11.1 to 12.0 */
  background: -moz-linear-gradient(
    right,
    #1b5e20,
    #A88049,
    #212121
  ); /* For Firefox 3.6 to 15 */
  background: linear-gradient(
    to right,
    #1b5e20,
    #A88049,
    #212121
  ); /* Standard syntax (must be last) */
}

.kit-black {
  background: #222;
  color: white;
}

.kit-blue {
  background: #009ee6;
}

.kit-green {
  background: #82b753;
}

.kit-lime {
  background: #b2ff59;
}

.kit-grey {
  background: #bab4af;
}

.kit-navy {
  background: #004674;
  color: white;
}

.kit-cyan {
  background: rgb(21, 210, 210);
}

.kit-orange {
  background: #ffaa47;
}

.kit-pink {
  background: #ffb1e8;
}

.kit-purple {
  background: #53246c;
  color: white;
}

.kit-yellow {
  background: #f1e321;
}

.kit-red {
  background: #b80029;
  color: white;
}

.kit-white {
  background: #f4f4f4;
  color: black !important;
}

.material-icons-title {
  font-size: 50px;
  color: #7d7d7d;
}
</style>
